import BadgeDetailLayout from '@/layouts/BadgeDetail';
import BadgeDetailMembers from '@/screens/BadgeDetail/BadgeDetailMembers';

export default function PrivateTabsChatBadgeBadgeIdIndexRoute() {
  return (
    <BadgeDetailLayout>
      <BadgeDetailMembers />
    </BadgeDetailLayout>
  );
}
